import { getStore } from '../store/store';
import { loadingCalendarEvents } from 'owa-calendar-events-store';
import { orchestrator } from 'satcheljs';
import { setCalendarLoadState } from 'owa-calendar-surface-calendars-store';

/**
 * Sets loading state for given calendar
 */
export const loadingCalendarEventsOrchestrator = orchestrator(
    loadingCalendarEvents,
    actionMessage => {
        const { calendarId, loadingState, lockId } = actionMessage;
        if (lockId === getStore().surfaceEventsLockId) {
            setCalendarLoadState(calendarId, loadingState);
        }
    }
);
